<template>
    <div></div>
</template>

<script>
export default {
  name: 'MessageComponent',
  methods: {
    /**
     *
     * @param type (success warning info error)
     * @param text
     */
    qcMessage({ type, text }) {
      // eslint-disable-next-line eqeqeq
      if (type == 'success') {
        this.$message({
          message: text,
          type: 'success'
        })
        // eslint-disable-next-line eqeqeq
      } else if (type == 'warning') {
        this.$message({
          message: text,
          type: 'warning'
        })
        // eslint-disable-next-line eqeqeq
      } else if (type == 'info') {
        this.$message(text)
        // eslint-disable-next-line eqeqeq
      } else if (type == 'error') {
        this.$message.error(text)
      }
    }
  },
  mounted() {
    window.entityMessage = this.qcMessage
  }
}
</script>

<style scoped>

</style>
